import { Badge } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { useToDoCount } from '../../hooks/useToDoCount'

export const ToDoCountBadge = (): ReactElement | null => {
  const { count, isLoading } = useToDoCount()

  if (!count || isLoading) {
    return null
  }

  return (
    <Badge color="danger" mode="subtle">
      {count}
    </Badge>
  )
}
